import React, { createContext, useCallback, useContext, useMemo, useState } from "react";

const STORAGE_KEY = "black-mirror-theme";
const ThemeContext = createContext(null);

function applyTheme(theme) {
  const root = document.documentElement;
  root.classList.add("theme-changing");
  root.classList.toggle("dark", theme === "dark");
  root.dataset.theme = theme;
  root.style.colorScheme = theme;
  const meta = document.querySelector('meta[name="theme-color"]');
  if (meta) meta.setAttribute("content", theme === "dark" ? "#0A0A0B" : "#F4F4F5");
  window.setTimeout(() => root.classList.remove("theme-changing"), 60);
}

export function ThemeProvider({ children }) {
  const [theme, setThemeState] = useState(() => (
    document.documentElement.classList.contains("dark") ? "dark" : "light"
  ));

  const setTheme = useCallback((nextTheme) => {
    const normalized = nextTheme === "dark" ? "dark" : "light";
    localStorage.setItem(STORAGE_KEY, normalized);
    applyTheme(normalized);
    setThemeState(normalized);
  }, []);

  const toggleTheme = useCallback(() => {
    setTheme(theme === "dark" ? "light" : "dark");
  }, [setTheme, theme]);

  const value = useMemo(() => ({ theme, setTheme, toggleTheme }), [setTheme, theme, toggleTheme]);
  return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>;
}

export function useTheme() {
  const context = useContext(ThemeContext);
  if (!context) throw new Error("useTheme must be used within ThemeProvider");
  return context;
}

export { STORAGE_KEY };